import Text from "components/labels/Text";
import Title from "components/labels/Title";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ButtonLinkAccount from "components/buttons/primary-buttons/ButtonLinkAccount";
import { Redirect, useHistory } from "react-router";
import { Grid } from "@material-ui/core";

interface Props {
    location: {
        state: {
            content?: InformationPageType;
        };
    };
}

export enum InformationPageType {
    NO_LINK_ACCOUNT,
    GENERIC_ERROR,
}

const InformationPageStyle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 150px;
    padding-bottom: 150px;
`;

export const redirectToInfomationPage = (content: InformationPageType): React.ReactElement => {
    return (
        <Redirect
            to={{
                pathname: `/information`,
                state: {
                    content,
                },
            }}
        />
    );
};

const Information = ({ location }: Props): React.ReactElement => {
    const { content } = location.state;
    const { t } = useTranslation();

    const history = useHistory();

    const title = () => {
        if (content === InformationPageType.NO_LINK_ACCOUNT) {
            return t("Common.Error.itsmeNotLinked.Title");
        }
        return t("Common.Error.Technical");
    };

    const subTitle = () => {
        if (content === InformationPageType.NO_LINK_ACCOUNT) {
            return t("Common.Error.itsmeNotLinked.Subtitle");
        }
        return t("Common.Error.Unknown");
    };

    const handleClick = () => {
        if (content === InformationPageType.NO_LINK_ACCOUNT) {
            history.push("/onboarding");
        }
    };

    const InfoLink = () => {
        if (content === InformationPageType.NO_LINK_ACCOUNT) {
            return <ButtonLinkAccount onClick={handleClick} />;
        }
        return <></>;
    };
    return (
        <Grid container>
            <Grid item xs={3} />
            <Grid item xs>
                <InformationPageStyle>
                    <Title>{title()}</Title>
                    <Text>{subTitle()}</Text>
                    <InfoLink />
                </InformationPageStyle>
            </Grid>
            <Grid item xs={3} />
        </Grid>
    );
};

export default Information;
